<template>
	<main id="maching_top_main" class="maching_main">
		<div class="bg01">
		<div class="bg02">
			<div class="content">
				<div id="what">
					<h2><img src="../assets/img/common/what_title.png" alt="推し家診断とは"></h2>
					<div class="txt_box">
						<p>ハウスメーカーってたくさんありすぎて、どこを選んでいいのかわからない！<br>だからこそ、見た目で選ぶから見つかる、あなたが本当に好きなお家。<br>&nbsp;<br>下のボタン「内観」「外観」を押すと、20枚のお家の写真が表示されます。<br>「好き」「うーん」の２択を直感で選んでください。<br>最後にあなたが選んだお家と、それを作っているハウスメーカーが表示されます。<br><strong>&nbsp;<br>あなたが選んだ「好きな見た目のお家」が、<br class="visible_pc">きっと、お家探しやハウスメーカー選びに役立つはず！</strong></p>
						<div class="chara_box"><p class="chara"><img src="../assets/img/common/what_chara.png" alt=""></p></div>
					</div>
				</div>
				<div id="top_btn_box">
					<p class="naikan"><router-link :to="{name:'Select',params:{build:'inner'}}"><img src="../assets/img/common/btn_txt_naikan.png" alt=""></router-link></p>
					<p class="gaikan"><router-link :to="{name:'Select',params:{build:'outer'}}"><img src="../assets/img/common/btn_txt_gaikan.png" alt=""></router-link></p>
				</div>
			</div>
		</div>
		</div>
	</main>
</template>

<script>
export default {
  name: 'Top',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
